var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.4}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }